import Login from "@/pages/Login";

export const API_ENDPOINTS = {
    AUTH: {
        
        SIGNUP: "/?activity=SignUp",
        LOGIN: "/?activity=Login",
        ADDAUTHORIZEDSIGNATORY: "/?activity=AddAuthorizedSignatory",
        SENDOTP: "/?activity=RequestOtp",
        VERIFYOTP: "/?activity=VerifyOtp",
        // LOGOUT: "/auth/logout",
        
    },
    PROFILE: {
        GETUSERPROFILE: "/?activity=GetUserProfile",
    },
    BUILDER: {
        DETAILS: "/?activity=GetBuilderDetail",
    },
    ADMIN: {
        GETBUILDERMANAGEMENTLIST: "/?activity=GetBuilderManagementList",
        GETBUILDERPROFILE: "/?activity=GetBuilderProfile",
        GETPROJECTCOMPLIANCELIST: "/?activity=GetProjectComplianceList",
        GETBUYERMANAGEMENTLIST: "/?activity=GetBuyerManagementList",
        GETBUYERDETAIL: "/?activity=GetBuyerDetail",
        GETBUYERPROFILE: "/?activity=GetBuyerProfile",
        GETBROKERMANAGEMENTLIST: "/?activity=GetBrokerManagementList",
        GETBROKERDETAIL: "/?activity=GetBrokerDetail",
        LISTROLES: "/?activity=ListRoles",
        LISTBUILDERSTATUSES: "/?activity=ListBuilderStatuses",
        SETBUILDERSTATUS: "/?activity=SetBuilderStatus",
        SETBUILDERKYCDOCUMENTSTATUS: "/?activity=SetBuilderKycDocumentStatus",
        LISTROLESTATUSES: "/?activity=ListRoleStatuses",
        SETUSERROLESTATUS: "/?activity=SetUserRoleStatus",
        GETBUILDERPROJECTSTATUSMANAGEMENT: "/?activity=GetBuilderProjectStatusManagement",
        SETBUILDERPROJECTSTATUS: "/?activity=SetBuilderProjectStatus",
        SETPROJECTPROPERTYSTATUS: "/?activity=SetProjectPropertyStatus",
    }


} as const;
